<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('system.noticeTitle')">
                <a-input v-model="queryParam.noticeTitle" :placeholder="$t('system.inputPlaceholder')" allow-clear />
              </a-form-item>
            </a-col>
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="操作人员">-->
<!--                <a-input v-model="queryParam.createBy" placeholder="请输入" allow-clear />-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('system.noticeType')">
                  <a-select :placeholder="$t('system.selectPlaceholder')" v-model="queryParam.noticeType" style="width: 100%" allow-clear>
                    <a-select-option v-for="(d, index) in dict.type['sys_notice_type']" :key="index" :value="d.value">{{
                      d.label }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'" />-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['system:notice:add']">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="handleUpdate(undefined, ids)"
                  v-hasPermi="['system:notice:edit']">
          <a-icon type="edit" />{{ $t('common.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:notice:remove']">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <table-setting
          style="float: right"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 新增/编辑表单组件 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :bordered="tableBordered" :scroll="{ x: 'max-content' }">
        <span slot="noticeType" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_type']" :value="record.noticeType" />
        </span>
<!--        <span slot="status" slot-scope="text, record">-->
<!--          <dict-tag :options="dict.type['sys_notice_status']" :value="record.status === '1' ? '0' : '1'" />-->
<!--        </span>-->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
            <a-divider type="vertical" v-hasPermi="['system:notice:edit']" />
           <a @click="handleUpdate(record, undefined)" v-hasPermi="['system:notice:edit']">
              <a-icon type="edit" />{{ $t('common.edit') }}
            </a>
            <a-divider type="vertical" v-hasPermi="['system:notice:remove']" />
            <a @click="handleDelete(record)" v-hasPermi="['system:notice:remove']">
              <a-icon type="delete" />{{ $t('common.delete') }}
            </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageNotice, delNotice } from '@/api/system/notice'
import { tableMixin } from '@/store/table-mixin'
import i18nMixin from '@/store/i18n-mixin'
import CreateForm from './CreateForm'

export default {
  name: 'Notice',
  components: {
    CreateForm
  },
  mixins: [tableMixin, i18nMixin],
  dicts: ['sys_notice_status', 'sys_notice_type'],
  data() {
    return {
      /**
       *
      dict.type['sys_notice_type']: [{
        label: '正常',
        value: '1'
      }, {
        label: '停用',
        value: '0'
      }]
       */
      statusOptions: [
        {
          label: '正常',
          value: '0'
        }, {
          label: '停用',
          value: '1'
        }
      ],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用（选择的数据不是1条时禁用编辑按钮）
      single: true,
      // 非多个禁用（没有选择数据时禁用删除按钮）
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        noticeTitle: undefined,
        createBy: undefined,
        status: undefined
      },
    }
  },
  filters: {
  },
  created() {
    this.getList()
    /**编辑页面接收到更新通知消息的数�?*/
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: '10%',
          align: 'center'
        },
        {
          title: this.$t('system.noticeId'),
          dataIndex: 'id',
          width: '10%',
          align: 'center'
        },
        {
          title: this.$t('system.noticeTitle'),
          dataIndex: this.currentLang === 'zh-CN' ? 'noticeTitleIn' : 'noticeTitleEn',
          width: '20%',
          align: 'center'
        },
        // {
        //   title: this.$t('system.noticeType'),
        //   dataIndex: 'noticeType',
        //   scopedSlots: { customRender: 'noticeType' },
        //   width: '15%',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('system.createBy'),
        //   dataIndex: 'createBy',
        //   width: '15%',
        //   align: 'center'
        // },
        {
          title: this.$t('system.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: '20%',
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 200,
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    /**
     * 查询公告列表
     */
    getList() {
      this.loading = true
      pageNotice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = Number(response.data.total)
        this.loading = false
        // 查询后重置选择状态，确保按钮禁用状态正确
        this.onSelectChange([], [])
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        noticeTitle: undefined,
        createBy: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const noticeIds = row.id || this.ids
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + noticeIds,
        onOk() {
          return delNotice(noticeIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
            })
        },
        onCancel() { }
      })
    },
    /**
     * 新增按钮操作
     */
    handleAdd() {
      this.$refs.createForm.handleAdd()
    },
    /**
     * 修改按钮操作
     * @param {Object} row - 行数据（单行修改时传入，批量修改时不传）
     * @param {Number|String} ids - ID（批量修改时传入）
     */
    handleUpdate(row, ids) {
      this.$refs.createForm.handleUpdate(row, ids)
    }
  }
}
</script>
